import DefaultWidgetTemplate from '../DefaultWidgetTemplate';

export default function EnvironmentalAspectsAssessmentDefaultWidget({ module }) {
  return (
    <DefaultWidgetTemplate
      module={module}
      route="user_module_environmentalAspectsAssessment_assessment_current"
    />
  );
}
